import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "mb-2 text-500 text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "text-4xl"
}
const _hoisted_8 = {
  key: 1,
  class: "text-4xl text-pink-600"
}

import Menu from "primevue/menu";
import Card from "primevue/card";
import { ref, computed } from "vue";
import { ISubscribedTargetResponse } from "@evolutivelabs/quokka-common";
import Chip from "primevue/chip";
import { useUserStore } from "@/store/user.store";
import { useSubscribedTargetStore } from "@/store/subscribedTarget.store";
import { calculateTimeAgo } from "./utils";


export default /*#__PURE__*/_defineComponent({
  props: {
    target: null
  },
  emits: ["cancel-subscribe", "rename-subscribe", "copy-succeed"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "cancel-subscribe"): void;
  (e: "rename-subscribe"): void;
  (e: "copy-succeed"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  target: ISubscribedTargetResponse;
}





const displayName = computed<string>(() => {
  return props.target.displayName || props.target.title;
});
const userStore = useUserStore();
const subscribedTargetStore = useSubscribedTargetStore();

const menuItems = [
  {
    label: "rename",
    icon: "pi pi-pencil",
    command() {
      emits("rename-subscribe");
    },
  },
  {
    label: "delete",
    icon: "pi pi-trash",
    command() {
      subscribedTargetStore.remove(props.target.id, userStore.user.id);
    },
  },
];
const menu = ref<InstanceType<typeof Menu>>();

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}

const isChipHovered = ref<boolean>(false);
const chipText = computed(() => {
  return isChipHovered.value
    ? props.target.owner?.email
    : props.target.owner?.displayName;
});
const copyMail = async () => {
  if (props.target.owner?.email === undefined) return;
  await navigator.clipboard.writeText(props.target.owner?.email);
  emits("copy-succeed");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "shadow-2 m-3 w-3" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: __props.target.favicon,
              height: "17",
              class: "pi pi-globe mr-1"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(displayName)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(calculateTimeAgo)(props.target.valueUpdateAt)), 1),
          (typeof props.target.value === 'number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(props.target.value), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "Value Not Found 😭"))
        ]),
        _createElementVNode("div", { class: "flex flex-column align-items-end" }, [
          _createElementVNode("div", {
            class: "pi pi-cog cursor-pointer",
            onClick: toggleMenu
          })
        ])
      ]),
      _createVNode(_unref(Menu), {
        ref: (_value, _refs) => {
          _refs['menu'] = _value
          menu.value = _value
        },
        popup: "",
        model: menuItems
      }, null, 512)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Chip), {
        class: "owner-chip text-xs cursor-pointer",
        onClick: copyMail,
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isChipHovered.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isChipHovered.value = false)),
        label: _unref(chipText),
        image: isChipHovered.value ? '' : props.target.owner.picture,
        icon: isChipHovered.value ? 'pi pi-copy' : ''
      }, null, 8, ["label", "image", "icon"])
    ]),
    _: 1
  }))
}
}

})